import React from "react";
import { connect } from "react-redux";
import {
  addToCart,
  clearCart,
  clearLocalStorage,
  deleteCookies,
  getCartDetails,
  getCookie,
  getCurrentDate,
  getFormattedDate,
  setCookies,
} from "../util";
import {
  getActivities,
  getAvailability,
  getEscalationMatrix,
  toggleAuthStatus,
  getSlotUnavailabilityStatus,
  updateCartData,
  switchClub,
  oneSignalUpdate,
  markNoShow,
  enableReschedule,
  syncAvailability,
} from "../external/actions";
import External from "../external/external";
import Header from "../components/header";
import ActivitiesBar from "../components/actvitiesBar";
import Loader from "../components/loader";
import AvailabilityPane from "../components/availabilityPane";
import Navigation from "../components/navigation";
import SwitchClubDialog from "../components/switchClubDialog";
import UnavailabilityDialog from "../components/unavailabilityDialog";
import EscalationMatrixDialog from "../components/escalationMatrixDialog";
import ConfirmationDialog from "../components/confirmationDialog";
import { toaster } from "evergreen-ui";
import EditAmountDialog from "../components/editAmountDialog";
import GetInTouchDialog from "../components/getInTouchDialog";
import MenuDrawer from "../components/menuDrawer";
import ChangePasswordDialog from "../components/changePasswordDialog";
import AddDeskPersonDialog from "../components/addDeskPersonDialog";

class Availability extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedActivityIndex: 0,

      loader: true,
      loaderType1: false,
      menuDrawerIsShown: false,
      switchClubDialogIsShown: false,
      changePasswordDialogIsShown: false,
      addDeskPersonDialogIsShown: false,
      unavailabilityDialogIsShown: false,
      escalationMatrixDialogIsShown: false,
      confirmationDialog: {
        isShown: false,
        header: "",
        confirmLabel: "",
        cancelLabel: "",
        intent: "none",
        information: "",
        action: null,
        cancelAction: null,
      },
      editAmountDialogIsShown: false,
      editAmountData: {},
      getInTouchDialogIsShown: false,
      getInTouchData: {},
    };
  }

  updateAvailability = async () => {
    await this.setState({
      loader: true,
    });
    const { activityData, date } = this.props;
    const { selectedActivityIndex } = this.state;
    const activity = parseInt(
      Object.keys(activityData["activities"])[selectedActivityIndex]
    );
    if (activity) {
      await this.props.dispatch(
        getAvailability({
          activityIds: [activity],
          activityStartDate: getFormattedDate(date),
          activityEndDate: getFormattedDate(date),
          customerStatus: 0,
        })
      );
      if (!this.props.availabilityData["requestStatus"]) {
        toaster.danger(this.props.availabilityData["message"], {
          id: "availability",
        });
      }
    }
    this.setState({
      loader: false,
    });
  };

  updateSelectedActivity = async () => {
    const activityIndex = localStorage.getItem("selectedActivityIndex");
    localStorage.setItem("selectedActivityIndex", activityIndex || 0);
    await this.setState({
      selectedActivityIndex: parseInt(activityIndex) || 0,
    });
  };

  componentDidMount = async () => {
    const datePickers = document.getElementsByClassName(
      "ant-picker-panel-container"
    );
    Array.from(datePickers).forEach((el) =>
      el.childNodes[0].setAttribute("inputMode", "none")
    );
    let onesignalId = localStorage.getItem("onesignalId") || false;

    // if (cart.isBulkBooking) {
    //   this.props.dispatch(updateCartData(clearCart()))
    // }
    if (onesignalId) {
      let body = {
        onesignalId: onesignalId,
        app: true,
      };
      await this.props.dispatch(oneSignalUpdate(body));
    }

    if (!getCookie("authToken")) {
      this.props.history.push("/login");
    } else {
      await this.updateSelectedActivity();
      await this.props.dispatch(getActivities());
      await this.props.dispatch(updateCartData(getCartDetails()));
      await this.updateAvailability();
      await this.props.dispatch(getEscalationMatrix());
    }
  };

  componentDidUpdate = () => {
    if (!this.props.authStatus && !getCookie("authToken")) {
      this.props.history.push("/login");
    }
  };

  clearCartCheck = async (action, information) => {
    const { cart } = this.props;
    if (cart && cart.slots && cart.slots.length) {
      await this.showConfirmationDialog({
        status: true,
        confirmLabel: "Clear & Proceed",
        information,
        action: async () => {
          await this.showConfirmationDialog({
            status: false,
          });
          this.props.dispatch(updateCartData(clearCart()));
          action();
        },
      });
    } else {
      action();
    }
  };

  activityChange = async (activityIndex) => {
    await this.clearCartCheck(async () => {
      await this.setState({
        selectedActivityIndex: activityIndex,
        loader: true,
      });
      localStorage.setItem("selectedActivityIndex", activityIndex);
      await this.updateAvailability();
    }, "Clear cart to change activity");
  };

  dateChange = async (date) => {
    await this.clearCartCheck(async () => {
      await this.props.dispatch({ type: "SET_AVAILABILITY_DATE", data: date });
      await this.setState({
        loader: true,
      });
      await this.updateAvailability();
    }, "Clear cart to change date");
  };

  showMenuDrawer = async (status) => {
    await this.setState({
      menuDrawerIsShown: status,
    });
  };

  showSwitchClubDialog = async (status) => {
    this.setState({
      menuDrawerIsShown: false,
      switchClubDialogIsShown: status,
    });
  };

  showChangePasswordDialog = async (status) => {
    this.setState({
      changePasswordDialogIsShown: status,
    });
  };

  showAddDeskPersonDialog = async (status) => {
    this.setState({
      addDeskPersonDialogIsShown: status,
    });
  };

  syncAvailability = () => {
    this.props.dispatch(syncAvailability());
  };

  switchClub = async (club) => {
    let onesignalId = (await localStorage.getItem("onesignal")) || "";
    let data = {
      onesignalId: onesignalId,
      app: true,
    };
    const result = Object.assign(club, data);
    await this.showSwitchClubDialog(false);
    this.setState({
      loaderType1: true,
    });
    await this.props.dispatch(switchClub(result));
    await this.props.dispatch(updateCartData(clearCart()));
    await deleteCookies();
    // localStorage.removeItem('lastNotification')
    // localStorage.removeItem('notifications')
    await setCookies(this.props.switchClubData["userAuth"]);
    localStorage.setItem("selectedActivityIndex", 0);
    this.props.history.push("/login");
  };

  showEscalationMatrixDialog = async (status) => {
    await this.setState({
      menuDrawerIsShown: false,
      escalationMatrixDialogIsShown: status,
    });
  };

  logout = async () => {
    let onesignalId = (await localStorage.getItem("onesignal")) || "";
    let body = { onesignalId: onesignalId, app: true };
    await External.logout(body);
    deleteCookies();
    clearLocalStorage();
    this.props.dispatch(toggleAuthStatus());
    this.props.history.push("/login");
  };

  showUnavailabilityDialog = async (status, slot = null) => {
    const { activityData, date } = this.props;
    const { selectedActivityIndex } = this.state;
    let activityId = parseInt(
      Object.keys(activityData["activities"])[selectedActivityIndex]
    );
    await this.setState({
      loaderType1: true,
    });
    if (status) {
      await this.props.dispatch(
        getSlotUnavailabilityStatus({
          activityId: activityId,
          date: getFormattedDate(date),
          slot,
        })
      );
    }

    if (this.props.slotUnavailabilityData) {
      if (this.props.slotUnavailabilityData.requestStatus === 1) {
        await this.setState({
          unavailabilityDialogIsShown: status,
        });
      } else {
        toaster.warning(this.props.slotUnavailabilityData["message"]);
      }
    }
    await this.setState({
      loaderType1: false,
    });
  };

  bookNow = async (date, slot, slotId) => {
    const { cart } = this.props;
    if (!(cart && cart.slots && cart.slots.length)) {
      await this.props.dispatch(
        updateCartData(addToCart({ date, slot, slotId }))
      );
      this.props.history.push({
        pathname: "/checkout",
        state: { isBulkBooking: false, bulkBookingData: {} },
      });
    } else {
      toaster.warning("Please select continuous slots", {
        id: "continuous-slots",
      });
    }
  };

  bookingCancellation = async (bookingId) => {
    await this.showConfirmationDialog({
      isShown: false,
    });
    await this.setState({
      loaderType1: true,
    });
    const cancellation = await External.cancelBooking({
      bookingId: bookingId,
      patternBookingId: null,
      cancelRemarks: "",
      playoCancelRemarks: "",
      refundMode: "Cash",
      refundType: 1,
      transactionData: {
        type: -1,
        mode: 1,
        handler: getCookie("username"),
        place: "Partner-App",
      },
    });
    await this.updateAvailability();
    await this.setState({
      loaderType1: false,
    });
    if (cancellation.data.requestStatus === 1) {
      toaster.success("Booking Cancelled", {
        id: "cancel",
      });
    } else if (cancellation.data.requestStatus === -1) {
      toaster.warning("you don't have permission", {
        id: "cancel",
      });
    } else {
      toaster.danger(cancellation.data["message"], {
        id: "cancel",
      });
    }
  };

  showConfirmationDialog = async (data) => {
    await this.setState({
      confirmationDialog: {
        isShown: data["status"] || false,
        header: data["header"] || false,
        intent: data["intent"] || "none",
        confirmLabel: data["confirmLabel"] || "",
        cancelLabel: data["cancelLabel"] || "Cancel",
        information: data["information"] || "",
        action: data["action"] || null,
      },
    });
  };

  showEditAmountDialog = async (status, editAmountData = {}) => {
    await this.setState({
      editAmountDialogIsShown: status,
      editAmountData,
    });
  };

  sendBookingPaymentLink = async (bookingId) => {
    const paymentLink = await External.sendBookingPaymentLink({ bookingId });
    if (paymentLink.data["requestStatus"]) {
      await this.showUnavailabilityDialog(false);
      toaster.success("Payment Link Sent", {
        id: "send-payment-link",
      });
    } else {
      toaster.warning(paymentLink.data["message"], {
        id: "send-payment-link",
      });
    }
  };

  showGetInTouchDialog = async (status, getInTouchData = {}) => {
    await this.setState({
      getInTouchDialogIsShown: status,
      getInTouchData,
    });
  };

  onNoShow = async (bookingId) => {
    let reqParams = { bookingId: bookingId };
    await this.props.dispatch(markNoShow(reqParams));

    if (this.props.markNoShow) {
      if (this.props.markNoShow.requestStatus === -1) {
        toaster.notify("Sorry, you don't have permission to do that");
      } else if (this.props.markNoShow.requestStatus === 1) {
        toaster.success(this.props.markNoShow.message);
        this.showUnavailabilityDialog(false);
      } else if (this.props.markNoShow.requestStatus === 0) {
        toaster.danger(this.props.markNoShow.message);
      }
    }
  };
  enableReschedule = async (bookingId, startTime) => {
    let reqParams = { bookingId: bookingId };
    await this.props.dispatch(enableReschedule(reqParams));

    if (this.props.enableReschedule) {
      if (this.props.enableReschedule.requestStatus === -1) {
        toaster.notify("Sorry, you don't have permission to do that");
      } else if (this.props.enableReschedule.requestStatus === 1) {
        toaster.success(this.props.enableReschedule.message);
        this.showUnavailabilityDialog(true, startTime);
      } else if (this.props.enableReschedule.requestStatus === 0) {
        toaster.danger(this.props.enableReschedule.message);
      }
    }
  };

  render() {
    const {
      selectedActivityIndex,

      loader,
      menuDrawerIsShown,
      switchClubDialogIsShown,
      unavailabilityDialogIsShown,
      escalationMatrixDialogIsShown,
      confirmationDialog,
      loaderType1,
      editAmountDialogIsShown,
      editAmountData,
      changePasswordDialogIsShown,
      addDeskPersonDialogIsShown,
      getInTouchDialogIsShown,
      getInTouchData,
    } = this.state;
    let { date } = this.props;
    return (
      <React.Fragment>
        <Header
          showMenuDrawer={this.showMenuDrawer}
          date={date}
          dateChange={this.dateChange}
          updateAvailability={this.updateAvailability}
        />
        <ActivitiesBar
          selectedActivityIndex={selectedActivityIndex}
          activityChange={this.activityChange}
        />
        {loaderType1 && <Loader type={1} top={110} bottom={60} />}
        {loader ? (
          <Loader />
        ) : (
          <AvailabilityPane
            selectedActivityIndex={selectedActivityIndex}
            date={date}
            showUnavailabilityDialog={this.showUnavailabilityDialog}
            bookNow={this.bookNow}
          />
        )}
        <Navigation
          date={date}
          dateChange={this.dateChange}
          clearCart={clearCart}
        />
        <MenuDrawer
          isShown={menuDrawerIsShown}
          showMenuDrawer={this.showMenuDrawer}
          showEscalationMatrixDialog={this.showEscalationMatrixDialog}
          showConfirmationDialog={this.showConfirmationDialog}
          logout={this.logout}
          showSwitchClubDialog={this.showSwitchClubDialog}
          showChangePasswordDialog={this.showChangePasswordDialog}
          showAddDeskPersonDialog={this.showAddDeskPersonDialog}
          syncAvailability={this.syncAvailability}
        />
        <SwitchClubDialog
          isShown={switchClubDialogIsShown}
          showDialog={this.showSwitchClubDialog}
          switchClub={this.switchClub}
        />
        <ChangePasswordDialog
          isShown={changePasswordDialogIsShown}
          showDialog={this.showChangePasswordDialog}
          showConfirmationDialog={this.showConfirmationDialog}
          logout={this.logout}
        />
        <AddDeskPersonDialog
          isShown={addDeskPersonDialogIsShown}
          showDialog={this.showAddDeskPersonDialog}
        />
        <UnavailabilityDialog
          isShown={unavailabilityDialogIsShown}
          showDialog={this.showUnavailabilityDialog}
          date={date}
          showConfirmationDialog={this.showConfirmationDialog}
          cancelBooking={this.bookingCancellation}
          showEditAmountDialog={this.showEditAmountDialog}
          sendBookingPaymentLink={this.sendBookingPaymentLink}
          showGetInTouchDialog={this.showGetInTouchDialog}
          onNoShow={this.onNoShow}
          enableReschedule={this.enableReschedule}
        />
        <EscalationMatrixDialog
          isShown={escalationMatrixDialogIsShown}
          showDialog={this.showEscalationMatrixDialog}
        />
        <ConfirmationDialog
          showDialog={this.showConfirmationDialog}
          isShown={confirmationDialog.isShown}
          header={confirmationDialog.header}
          confirmLabel={confirmationDialog.confirmLabel}
          cancelLabel={confirmationDialog.cancelLabel}
          intent={confirmationDialog.intent}
          information={confirmationDialog.information}
          action={confirmationDialog.action}
          cancelAction={confirmationDialog.cancelAction}
        />
        <EditAmountDialog
          isShown={editAmountDialogIsShown}
          showDialog={this.showEditAmountDialog}
          source={"availability"}
          editAmountData={editAmountData}
          showUnavailabilityDialog={this.showUnavailabilityDialog}
        />
        <GetInTouchDialog
          isShown={getInTouchDialogIsShown}
          showDialog={this.showGetInTouchDialog}
          source={"availability"}
          getInTouchData={getInTouchData}
          showUnavailabilityDialog={this.showUnavailabilityDialog}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({
  authStatus,
  activityData,
  availabilityData,
  cart,
  switchClubData,
  slotUnavailabilityData,
  markNoShow,
  enableReschedule,
  date,
}) => ({
  authStatus,
  activityData,
  availabilityData,
  cart,
  switchClubData,
  slotUnavailabilityData,
  markNoShow,
  enableReschedule,
  date,
});

export default connect(mapStateToProps)(Availability);
